var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H26.2933V15.1635H25.2741V1.04576H1.01912V16.3138H6.21662V17.3596H0V0Z",
    fill: "#F6931E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7836 5.01968H0.509411V3.97392H25.7836V5.01968Z",
    fill: "#F6931E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3347 9.00844H3.36284V7.96269H16.3347V9.00844Z",
    fill: "#F6931E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9061 11.5183H3.36284V10.4725H12.9061V11.5183Z",
    fill: "#F6931E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70674 14.6404H32V32H5.70674V14.6404ZM6.72586 15.6862V30.9542H30.9809V15.6862H6.72586Z",
    fill: "#F6931E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4004 28.5714H18.8571V27.5257H28.4004V28.5714Z",
    fill: "#F6931E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4004 26.2857H12.5714V25.24H28.4004V26.2857Z",
    fill: "#F6931E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.109 18.2856C25.6919 18.2856 25.2841 18.4093 24.9373 18.6411C24.5905 18.8728 24.3202 19.2022 24.1605 19.5876C24.0009 19.9729 23.9591 20.397 24.0405 20.8061C24.1219 21.2152 24.3228 21.5909 24.6177 21.8859C24.9127 22.1808 25.2884 22.3817 25.6975 22.4631C26.1066 22.5444 26.5307 22.5027 26.916 22.3431C27.3014 22.1834 27.6308 21.9131 27.8625 21.5663C28.0943 21.2195 28.2179 20.8117 28.2179 20.3946C28.2174 19.8355 27.995 19.2994 27.5996 18.904C27.2042 18.5086 26.6681 18.2862 26.109 18.2856ZM26.109 21.4029C25.9093 21.4029 25.7141 21.3437 25.5481 21.2327C25.382 21.1218 25.2527 20.9641 25.1763 20.7796C25.0999 20.595 25.08 20.392 25.119 20.1962C25.1581 20.0004 25.2543 19.8205 25.3956 19.6794C25.5369 19.5383 25.7168 19.4422 25.9127 19.4034C26.1086 19.3646 26.3116 19.3847 26.496 19.4613C26.6804 19.5378 26.838 19.6674 26.9488 19.8335C27.0596 19.9997 27.1186 20.1949 27.1184 20.3946C27.1181 20.6621 27.0116 20.9186 26.8223 21.1077C26.6331 21.2967 26.3765 21.4029 26.109 21.4029Z",
    fill: "#F6931E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.0427a4c7c95ec38aa91f756a15878b70.svg";
export { ForwardRef as ReactComponent };